import { createSlice } from '@reduxjs/toolkit';
import { updateLoader } from '../../_redux/LoaderSlice';
import { updateSnackbar } from '../../_redux/SnackbarSlice';
import { candidateStatusFilter } from '../../_utilities/internalexternalhelper';
import * as _ser from '../_apiHelpers/UserManagerApihelper';
import { fetchATSThemeConfig } from './ThemeSlice';
import { GetUserInfo } from '../../_utilities/getUserInfo';
import { Encrypt } from '../../_utilities/_encryptDecryptHelper';
const initalState = { data: null, message: '', code: null };
const initialSnackbar = { type: '', message: '' };

export const userManagerSlice = createSlice({
  name: 'UserManager',
  initialState: initalState,
  reducers: {
    userManagerStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    userManagerReducer: (state, action) => {
      if (action.payload.type !== '') {
        return {
          ...state,
          data: action.payload.username,
          code: action.payload.type,
          message:
            action.payload.type === 'Generate OTP'
              ? 'OTP sent successful'
              : action.payload.type === 'Otp Verified'
                ? 'OTP verified successful'
                : action.payload.type === 'passwordChanged'
                  ? 'Password changed successful'
                  : '',
        };
      } else {
        return { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { userManagerReducer, userManagerStartReducer } =
  userManagerSlice.actions;
export const userManagerAsync = (data, type) => async (dispatch) => {
  dispatch(updateLoader(true));
  if (type === 'forgotpassword') {
    const res = await _ser.ForgotPassword(data);
    dispatch(userManagerReducer(res));
  } else if (type === 'verifyOtp') {
    const res = await _ser.VerifyOtp(data);
    dispatch(userManagerReducer(res));
  } else if (type === 'generatePassword') {
    const res = await _ser.GeneratePassword(data);
    dispatch(userManagerReducer(res));
    // dispatch(updateSnackbar({ type: 'success', message: "Password updated successfully !!!" }));
  }
  dispatch(updateLoader(false));
};

export const getCustDetailsSlice = createSlice({
  name: 'GetCustDetails',
  initialState: initalState,
  reducers: {
    getCustDetailsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getCustDetailsReducer: async (state, action) => {
      if (action.payload.status === 200) {
        const myData = action.payload.data.user;
        // Encrypt(myData[0].dashboardConfig, 'DashboardConfig');
        sessionStorage.setItem('DashboardConfig', myData[0].dashboardConfig);
        // NOTE: User data is now stored in Redux AuthSlice via updateAuth()
        // No longer storing in localStorage - removed Encrypt() calls for security

        // Save RingCentral integration details in localStorage (integration-specific, not user auth data)
        const integrations = JSON.parse(myData[0]?.integrations || '[]');
        const ringCentralIntegration = integrations.find(
          (integration) => integration.attribute_5 === 'Ring Central'
        );
        if (ringCentralIntegration) {
          localStorage.setItem(
            'ringCentralIntegration',
            JSON.stringify(ringCentralIntegration)
          );
        }

        return {
          ...state,
          data: myData,
          code: action.payload.data?.code,
          message: action.payload.data?.message,
        };
      } else {
        let userInfoData = await GetUserInfo();
        if (userInfoData && userInfoData.length > 0) {
          return {
            ...state,
            data: userInfoData,
            message: action.payload.message,
          };
        } else {
          return { ...state, message: action.payload.message, data: null };
        }
      }
    },
  },
});
export const { getCustDetailsReducer, getCustDetailsStartReducer } =
  getCustDetailsSlice.actions;

export const getCustDetailsAsync = (data) => async (dispatch) => {
  if (data.userId) {
    dispatch(updateLoader(true));
    try {
      const res = await _ser.GetCustomerId(data);
      if (res.status === 200 && res.data.user[0]?.id) {
        // Then update customer details
        dispatch(getCustDetailsReducer(res));
      }
    } catch (error) {
      console.error('Error in getCustDetailsAsync:', error);
      // Handle error appropriately
    } finally {
      dispatch(updateLoader(false));
    }
  }
};

export const loginPageSlice = createSlice({
  name: 'LoginPage',
  initialState: initalState,
  reducers: {
    loginPageStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    loginPageReducer: (state, action) => {
      if (action.payload.status === 200) {
        return {
          ...state,
          data: action.payload.data?.data,
          code: action.payload.data?.code,
          message: action.payload.data?.message,
        };
      } else {
        alert('Customer Data Not found please login again....');
        return { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { loginPageReducer, loginPageStartReducer } =
  loginPageSlice.actions;
export const loginPageAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  const res = await _ser.LoginPage(data);
  dispatch(loginPageReducer(res));
  dispatch(updateLoader(false));
  dispatch(
    updateSnackbar({
      type: res.status === 200 ? 'success' : 'error',
      message: res.data.message,
    })
  );
};

export const customFieldsSlice = createSlice({
  name: 'CustomFields',
  initialState: initalState,
  reducers: {
    customFieldsStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    customFieldsReducer: (state, action) => {
      if (action.payload.status === 200) {
        return {
          ...state,
          data: action.payload.data?.customfeilds,
          code: action.payload.data?.code,
          message: action.payload.data?.message,
        };
      } else {
        alert('Customer Data Not found please login again....');
        return { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { customFieldsReducer, customFieldsStartReducer } =
  customFieldsSlice.actions;
export const customFieldsAsync = (id) => async (dispatch) => {
  dispatch(updateLoader(true));
  const res = await _ser.GetCustomFields(id);
  const customfeilds = candidateStatusFilter(res.data.customfeilds);
  dispatch(
    customFieldsReducer({
      ...res,
      data: { ...res.data, customfeilds: customfeilds },
    })
  );
  dispatch(updateLoader(false));
  // dispatch(updateSnackbar({ type: res.status === 200 ? "success" : "error", message: res.data.message }));
};

export const getEmailTemplatesSlice = createSlice({
  name: 'GetEmailTemplates',
  initialState: initalState,
  reducers: {
    getEmailTemplatesStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getEmailTemplatesReducer: (state, action) => {
      if (action.payload.status === 200) {
        return {
          ...state,
          data: action.payload.data?.emailtemplates,
          message: action.payload.data?.message,
        };
      } else {
        return { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { getEmailTemplatesReducer, getEmailTemplatesStartReducer } =
  getEmailTemplatesSlice.actions;
export const getEmailTemplatesAsync = (id, type) => async (dispatch) => {
  dispatch(updateLoader(true));
  const res = await _ser.GetEmailTemplates(id, type);
  dispatch(getEmailTemplatesReducer(res));
  dispatch(updateLoader(false));
  // dispatch(updateSnackbar({ type: res.status === 200 ? "success" : "error", message: res.data.message }));
};

export const getEmailTemplatebyIdSlice = createSlice({
  name: 'GetEmailTemplatebyId',
  initialState: initalState,
  reducers: {
    getEmailTemplatebyIdStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getEmailTemplatebyIdReducer: (state, action) => {
      if (action.payload.status === 200) {
        return {
          ...state,
          data: action.payload.data?.emailtemplates,
          message: action.payload.data?.message,
        };
      } else {
        return { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { getEmailTemplatebyIdReducer, getEmailTemplatebyIdStartReducer } =
  getEmailTemplatebyIdSlice.actions;
export const getEmailTemplatebyIdAsync =
  (customerId, id) => async (dispatch) => {
    dispatch(updateLoader(true));
    const res = await _ser.GetEmailTemplatebyId(customerId, id);
    dispatch(getEmailTemplatebyIdReducer(res));
    dispatch(updateLoader(false));
    // dispatch(updateSnackbar({ type: res.status === 200 ? "success" : "error", message: res.data.message }));
  };

export const SendEmailSlice = createSlice({
  name: 'SendEmail',
  initialState: initalState,
  reducers: {
    SendEmailStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    SendEmailReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.code,
            message: action.payload.data?.message,
            isloader: false,
          };
        }
      } else {
        return {
          ...state,
          message: action.payload.data?.message,
          data: null,
          isloader: false,
        };
      }
    },
  },
});
export const { SendEmailReducer, SendEmailStartReducer } =
  SendEmailSlice.actions;
export const SendEmailAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.SendEmail(data);
  if (res) {
    dispatch(SendEmailReducer(res));
    dispatch(updateLoader(false));
    setTimeout(() => {
      dispatch(
        updateSnackbar({
          type: res.status === 200 ? 'success' : 'error',
          message: res.data.message,
        })
      );
    }, 0);
  } else {
    dispatch(updateLoader(false));
  }
};

export const BulkEmailSlice = createSlice({
  name: 'BulkEmail',
  initialState: initalState,
  reducers: {
    BulkEmailStartReducer: (state, action) => {
      return { ...state, data: null, code: null, message: null, isLoading: false };
    },
    BulkEmailReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            code: action.payload.data?.code,
            data: {
              deliverySummary: action.payload.data?.emailDeliverySummary,
              unsubscribedRecipients: action.payload.data?.unsubscribedRecipients,
              unsubscribedCcRecipients: action.payload.data?.unsubscribedCcRecipients,
              ccProvided: action.payload.data?.ccProvided
            },
            message: action.payload.data?.message,
            isloader: false,
          };
        }
      } else {
        return {
          ...state,
          message: action.payload.data?.message,
          data: null,
          code: null,
          isloader: false,
        };
      }
    },
  },
});
export const { BulkEmailReducer, BulkEmailStartReducer } =
  BulkEmailSlice.actions;
export const BulkEmailAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.BulkEmail(data);
  dispatch(BulkEmailReducer(res));
  dispatch(updateLoader(false));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res.status === 200 ? 'success' : 'error',
        message: res.data.message,
      })
    );
  }, 0);
};

export const ClientBulkEmailSlice = createSlice({
  name: 'ClientBulkEmail',
  initialState: initalState,
  reducers: {
    ClientBulkEmailStartReducer: (state, action) => {
      return { ...state, data: null, isLoading: false };
    },
    ClientBulkEmailReducer: (state, action) => {
      if (action.payload.status === 200) {
        if (action.payload.data) {
          return {
            ...state,
            data: action.payload.data?.code,
            message: action.payload.data?.message,
            isloader: false,
          };
        }
      } else {
        return {
          ...state,
          message: action.payload.data?.message,
          data: null,
          isloader: false,
        };
      }
    },
  },
});
export const { ClientBulkEmailReducer, ClientBulkEmailStartReducer } =
  ClientBulkEmailSlice.actions;
export const ClientBulkEmailAsync = (data) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateSnackbar(initialSnackbar));
  const res = await _ser.ClientBulkEmail(data);
  dispatch(ClientBulkEmailReducer(res));
  dispatch(updateLoader(false));
  setTimeout(() => {
    dispatch(
      updateSnackbar({
        type: res.status === 200 ? 'success' : 'error',
        message: res.data.message,
      })
    );
  }, 0);
};

export const dashboardConfigSlice = createSlice({
  name: 'DashboardConfig',
  initialState: initalState,
  reducers: {
    updateDashboardConfigStart: (state) => {
      return { ...state, data: null };
    },
    updateDashboardConfigSuccess: (state, action) => {
      if (action.payload.status === 200) {
        const updatedConfig = action.payload.data.dashboardConfig;
        // Encrypt(updatedConfig, 'DashboardConfig');
        sessionStorage.setItem('DashboardConfig', updatedConfig);
        // NOTE: Dashboard config is now stored in Redux AuthSlice
        // No longer storing in localStorage - removed Encrypt() call
        return {
          ...state,
          data: updatedConfig,
          message: 'Dashboard configuration updated successfully!',
        };
      } else {
        return { ...state, message: action.payload.message, data: null };
      }
    },
    updateDashboardConfigFailure: (state, action) => {
      return { ...state, message: action.payload.message, data: null };
    },
  },
});

export const {
  updateDashboardConfigStart,
  updateDashboardConfigSuccess,
  updateDashboardConfigFailure,
} = dashboardConfigSlice.actions;

export const updateDashboardConfigAsync = (payload) => async (dispatch) => {
  dispatch(updateLoader(true));
  dispatch(updateDashboardConfigStart());

  try {
    const response = await _ser.UpdateDashboardConfig(payload);
    dispatch(updateDashboardConfigSuccess(response));
  } catch (error) {
    dispatch(updateDashboardConfigFailure({ message: error.message }));
  }

  dispatch(updateLoader(false));
};

export const getSmsTemplatesSlice = createSlice({
  name: 'GetSmsTemplates',
  initialState: initalState,
  reducers: {
    getSmsTemplatesStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getSmsTemplatesReducer: (state, action) => {
      if (action.payload.status === 200) {
        return {
          ...state,
          data: action.payload.data?.smstemplates,
          message: action.payload.data?.message,
        };
      } else {
        return { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { getSmsTemplatesReducer, getSmsTemplatesStartReducer } =
  getSmsTemplatesSlice.actions;
export const getSmsTemplatesAsync = (id) => async (dispatch) => {
  dispatch(updateLoader(true));
  const res = await _ser.GetSmsTemplates(id);
  dispatch(getSmsTemplatesReducer(res));
  dispatch(updateLoader(false));
  // dispatch(updateSnackbar({ type: res.status === 200 ? "success" : "error", message: res.data.message }));
};

export const getSmsTemplatebyIdSlice = createSlice({
  name: 'GetSmsTemplatebyId',
  initialState: initalState,
  reducers: {
    getSmsTemplatebyIdStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getSmsTemplatebyIdReducer: (state, action) => {
      if (action.payload.status === 200) {
        return {
          ...state,
          data: action.payload.data?.smstemplates,
          message: action.payload.data?.message,
        };
      } else {
        return { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { getSmsTemplatebyIdReducer, getSmsTemplatebyIdStartReducer } =
  getSmsTemplatebyIdSlice.actions;
export const getSmsTemplatebyIdAsync = (customerId, id) => async (dispatch) => {
  dispatch(updateLoader(true));
  const res = await _ser.GetSmsTemplatebyId(customerId, id);
  dispatch(getSmsTemplatebyIdReducer(res));
  dispatch(updateLoader(false));
  // dispatch(updateSnackbar({ type: res.status === 200 ? "success" : "error", message: res.data.message }));
};

export const getCustomMessagesSlice = createSlice({
  name: 'GetCustomMessages',
  initialState: initalState,
  reducers: {
    getCustomMessagesStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getCustomMessagesReducer: (state, action) => {
      if (action.payload.status === 200) {
        return {
          ...state,
          data: action.payload.data?.custommessageData,
          message: action.payload.data?.message,
        };
      } else {
        return { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { getCustomMessagesReducer, getCustomMessagesStartReducer } =
  getCustomMessagesSlice.actions;
export const getCustomMessagesAsync = (customerId) => async (dispatch) => {
  dispatch(updateLoader(true));
  const res = await _ser.fetchCustomMessages(customerId);
  dispatch(getCustomMessagesReducer(res));
  dispatch(updateLoader(false));
  return res;
};

export const getAccessTokenSlice = createSlice({
  name: 'GetAccessToken',
  initialState: initalState,
  reducers: {
    getAccessTokenStartReducer: (state, action) => {
      return { ...state, data: null };
    },
    getAccessTokenReducer: (state, action) => {
      // NOTE: Bearer tokens now handled via HTTP-only cookies - no localStorage storage
      if (action.payload.status === 200) {
        return {
          ...state,
          data: action.payload.data?.accesstoken,
          message: action.payload.data?.message,
        };
      } else {
        return { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { getAccessTokenReducer, getAccessTokenStartReducer } =
  getAccessTokenSlice.actions;
export const getAccessTokenAsync = (userId) => async (dispatch) => {
  dispatch(updateLoader(true));
  const res = await _ser.getAccessToken(userId);
  dispatch(getAccessTokenReducer(res));
  dispatch(updateLoader(false));
  // dispatch(updateSnackbar({ type: res.status === 200 ? "success" : "error", message: res.data.message }));
};

export const updateUserDetailsSlice = createSlice({
  name: 'UpdateUserDetails',
  initialState: initalState,
  reducers: {
    updateUserDetailsStartReducer: (state, action) => {
      return { ...state, data: null, code: null, message: '' };
    },
    updateUserDetailsReducer: (state, action) => {
      if (action.payload.status === 200) {
        return {
          ...state,
          data: action.payload.data?.data,
          code: action.payload.data?.code,
          message: action.payload.data?.message,
        };
      } else {
        return { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { updateUserDetailsReducer, updateUserDetailsStartReducer } =
  updateUserDetailsSlice.actions;
export const updateUserDetailsAsync = (data, id) => async (dispatch) => {
  dispatch(updateLoader(true));
  const res = await _ser.updateUserDetails(data, id);
  dispatch(updateUserDetailsReducer(res));
  dispatch(updateLoader(false));
  dispatch(
    updateSnackbar({
      type: res.status === 200 ? 'success' : 'error',
      message: res.data.message,
    })
  );
};

export const unsubscribeDetailsSlice = createSlice({
  name: 'UnsubscribeDetails',
  initialState: initalState,
  reducers: {
    unsubscribeDetailsStartReducer: (state, action) => {
      return { ...state, data: null, code: null, message: '' };
    },
    unsubscribeDetailsReducer: (state, action) => {
      if (action.payload.status === 200) {
        return {
          ...state,
          data: { companyName: action.payload.data?.companyName, email: action.payload.data?.emailId },
        };
      } else {
        return { ...state, message: action.payload.message, data: null };
      }
    },
  },
});
export const { unsubscribeDetailsReducer, unsubscribeDetailsStartReducer } = unsubscribeDetailsSlice.actions;
export const unsubscribeDetailsAsync = (token) => async (dispatch) => {
  dispatch(updateLoader(true));
  try {
    const res = await _ser.getUnsubscribeDetails(token);
    dispatch(unsubscribeDetailsReducer(res));
    dispatch(updateLoader(false));
    dispatch(
      updateSnackbar({
        type: res.status === 200 ? 'success' : 'error',
        message: res.data?.message || 'Action completed',
      })
    );
    return res;
  } catch (error) {
    dispatch(updateLoader(false));
    dispatch(
      unsubscribeDetailsReducer({
        status: error.response?.status || 400,
        message: error.response?.data?.message || error.message,
      })
    );
  }
};
